// RESPONSABILIDAD:
// - Abre información del chat
// - Permite abandonar la sala
// - acceso a administración si eres admin
// NO:
// - Ejecutar acciones técnicas aquí (eso va dentro del modal)

import React, { useEffect, useRef, useState } from "react";

export default function ChatOptionsMenu({
                                            onConfig,
                                            onLeave,
                                            disabled,
                                            canManage = false,
                                            onManage,
                                        }) {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    // Cerrar al hacer click fuera
    useEffect(() => {
        const handler = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, []);

    const closeAnd = (fn) => {
        setOpen(false);
        fn?.();
    };

    const handleManage = () => {
        // Si no nos pasan onManage, abre igualmente onConfig (modal actual)
        closeAnd(onManage || onConfig);
    };

    return (
        <div className="relative" ref={ref}>
            {/* Botón menú */}
            <button
                type="button"
                disabled={disabled}
                onClick={() => setOpen((v) => !v)}
                aria-label="Opciones del chat"
                title="Opciones del chat"
                className="
          inline-flex items-center justify-center
          h-10 w-10 rounded-full
          border border-gray-300
          bg-white text-gray-700
          hover:bg-gray-100
          focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
          disabled:opacity-50
          dark:bg-gray-900 dark:border-gray-700 dark:text-gray-200
          dark:hover:bg-gray-800 dark:focus:ring-offset-gray-900
        "
            >
                ⋮
            </button>

            {/* Menú */}
            {open && (
                <div
                    className="
            absolute right-0 mt-2 w-56
            rounded-xl border border-gray-200
            bg-white shadow-lg
            z-50 overflow-hidden
            dark:bg-gray-900 dark:border-gray-700
          "
                    role="menu"
                >
                    {/* Información */}
                    <button
                        type="button"
                        role="menuitem"
                        onClick={() => closeAnd(onConfig)}
                        className="
              w-full px-4 py-2.5 text-left text-sm
              text-gray-800 dark:text-gray-100
              hover:bg-gray-100 dark:hover:bg-gray-800
              focus:outline-none focus:bg-gray-100 dark:focus:bg-gray-800
            "
                    >
                        🔐 Permisos y usuarios
                    </button>

                    {/* Administración (solo admin) */}
                    {canManage && (
                        <>
                            <div className="h-px bg-gray-200 dark:bg-gray-700" />
                            <button
                                type="button"
                                role="menuitem"
                                onClick={handleManage}
                                className="
                  w-full px-4 py-2.5 text-left text-sm
                  text-gray-800 dark:text-gray-100
                  hover:bg-gray-100 dark:hover:bg-gray-800
                  focus:outline-none focus:bg-gray-100 dark:focus:bg-gray-800
                "
                            >
                                ⚙️ Administrar sala
                            </button>
                        </>
                    )}

                    <div className="h-px bg-gray-200 dark:bg-gray-700" />

                    {/* Abandonar */}
                    <button
                        type="button"
                        role="menuitem"
                        onClick={() => closeAnd(onLeave)}
                        className="
              w-full px-4 py-2.5 text-left text-sm
              text-red-600
              hover:bg-red-50 dark:hover:bg-red-950/30
              focus:outline-none focus:bg-red-50 dark:focus:bg-red-950/30
            "
                    >
                        🏃🏽‍♀️‍➡️ Abandonar sala
                    </button>
                </div>
            )}
        </div>
    );
}
